<ng-template>
    <div
        class="nw-menu-panel"
        (click)="close.emit()"
        (keydown.enter)="close.emit()"
        tabindex="-1"
        role="menu"
    >
        <ng-content></ng-content>
    </div>
</ng-template>
